import React from 'react';
import { Button, ConfigProvider, DatePicker } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import 'moment/locale/zh-cn';

import localeZH from 'antd/lib/locale/zh_CN';
import localeFR from 'antd/lib/locale/fr_FR';
import localeEN from 'antd/lib/locale/en_US';
import localeIT from 'antd/lib/locale/it_IT';
import localeKO from 'antd/lib/locale/ko_KR';
import localeNL from 'antd/lib/locale/nl_NL';
import { t } from '../../../../helpers/t';

import FilterWrapper from '../../FilterWrapper';
import {
  clearSearchFilters as clear,
  setOpenSearchFilter,
  updateSearchFilters as update,
} from '../../../../actions';
import ClearButton from '../ClearButton';

const FILTER_NAME = 'dates';
const { RangePicker } = DatePicker;

const DatesFilter = () => {
  const dispatch = useDispatch();

  const {
    openSearchFilter,
    parameters: {
      start_date: startDate,
      end_date: endDate,
    },
  } = useSelector((state) => state.searchFilters);
  const { userLocale } = useSelector((state) => state.env);

  const showMonthAndDay = (dateString) => moment(dateString).format('MMM D');
  const formatDatesForApi = (dateString) => moment(dateString).format('YYYY-MM-DD');

  const setDates = ([updatedStartDate, updatedEndDate]) => {
    dispatch(update({ start_date: formatDatesForApi(updatedStartDate) }));
    dispatch(update({ end_date: formatDatesForApi(updatedEndDate) }));
  };

  function disabledDate(current) {
    // Can not select days before today and today
    return current && current < moment().endOf('day');
  }

  const toggleFilterVisible = () => (
    openSearchFilter === FILTER_NAME
      ? dispatch(setOpenSearchFilter(null))
      : dispatch(setOpenSearchFilter(FILTER_NAME))
  );

  const resetFilter = () => {
    dispatch(clear(['start_date', 'end_date']));
    dispatch(setOpenSearchFilter(null));
  };

  const datesFilterOpen = openSearchFilter === FILTER_NAME;
  const datesPresent = (startDate && endDate);
  const buttonText = datesPresent
    ? `${showMonthAndDay(startDate)} - ${showMonthAndDay(endDate)}`
    : t('directives.listings.listingFilters.dates.title');

  let locale;
  switch (userLocale) {
    case 'fr-FR':
      locale = localeFR;
      break;
    case 'it-IT':
      locale = localeIT;
      break;
    case 'ko-KR':
      locale = localeKO;
      break;
    case 'nl-NL':
      locale = localeNL;
      break;
    case 'zh-HK':
      locale = localeZH;
      break;
    default:
      locale = localeEN;
      break;
  }

  return (
    <FilterWrapper>
      <ConfigProvider locale={locale}>
        {
          datesFilterOpen || datesPresent
            ? (
              <RangePicker
                open={datesFilterOpen}
                allowClear={false}
                onChange={setDates}
                format="MMM D"
                style={datesPresent ? { borderColor: '#57D497' } : {}}
                defaultValue={(startDate && endDate) ? [moment(startDate), moment(endDate)] : [null, null]}
                disabledDate={disabledDate}
                onOpenChange={(v) => {
                  if (!v && datesFilterOpen) {
                    dispatch(setOpenSearchFilter(null));
                  } else if (v && !datesFilterOpen) {
                    dispatch(setOpenSearchFilter(FILTER_NAME));
                  }
                }}
                renderExtraFooter={() => (
                  <ClearButton style={{ height: 40 }} onClick={resetFilter} />
                )}
              />
            )
            : (
              <Button
                className="more-filters"
                onClick={toggleFilterVisible}
              >
                {buttonText}
              </Button>
            )
        }
      </ConfigProvider>
    </FilterWrapper>
  );
};

export default DatesFilter;
